// Action Options
export var IPresetAnimation;
(function (IPresetAnimation) {
    IPresetAnimation["spin"] = "Spin";
    IPresetAnimation["orbit"] = "Orbit";
    IPresetAnimation["scale"] = "Scale";
    IPresetAnimation["move"] = "Move";
})(IPresetAnimation || (IPresetAnimation = {}));
export var ISocialProvider;
(function (ISocialProvider) {
    ISocialProvider["noSocial"] = "noSocial";
    ISocialProvider["facebook"] = "Facebook";
    ISocialProvider["instagram"] = "Instagram";
    ISocialProvider["linkedIn"] = "LinkedIn";
    ISocialProvider["twitter"] = "Twitter";
    ISocialProvider["youtube"] = "Youtube";
    ISocialProvider["spotify"] = "Spotify";
    ISocialProvider["soundCloud"] = "SoundCloud";
    ISocialProvider["reddit"] = "Reddit";
    ISocialProvider["tiktok"] = "TikTok";
    ISocialProvider["twitch"] = "Twitch";
    ISocialProvider["vimeo"] = "Vimeo";
    ISocialProvider["custom"] = "custom";
})(ISocialProvider || (ISocialProvider = {}));
export var IScormEventType;
(function (IScormEventType) {
    IScormEventType["progress"] = "progress";
    IScormEventType["completion"] = "completion";
})(IScormEventType || (IScormEventType = {}));
